<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <!--        <div v-if="$gate.isServiceAgent()">-->
        <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h2>Customers | Master</h2>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <a href="/home">Home</a>
                            </li>
                            <li class="breadcrumb-item active">
                                {{ $route.meta.title }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>

        <!-- Main content -->
        <section class="content">
            <br />
            <!-- main row for all icons  -->
            <div class="col-lg-12">
                <div class="card card-primary card-outline">
                    <div class="card-header">Customer Details</div>
                    <div class="card-body overflow-auto">
                        <div class="col-sm-12">
                            <div class="row">
                                <div class="col-sm-4">
                                    <input
                                        type="number"
                                        placeholder="Search customer using number"
                                        v-model="number"
                                        min="1000000000"
                                        class="form-control"
                                    />
                                </div>
                                <div class="col-sm-4">
                                    <button
                                        class="btn btn-primary"
                                        @click="searchCus"
                                    >
                                        <i class="fa fa-search"></i> Search
                                    </button>
                                </div>
                                <div class="col-sm-4 right-block" align="right">
                                    <button
                                        class="btn btn-danger"
                                        @click="addCus"
                                    >
                                        <i class="fa fa-plus"></i> Add Customer
                                    </button>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div class="col-sm-3">
                            <div class="form-group">
                                <span class="right badge badge-success">{{
                                    status
                                }}</span>
                            </div>
                        </div>
                        <br />
                        <div class="col-sm-12">
                            <div class="form-group">
                                <p><b>Customer Name:</b> {{ customer.name }}</p>
                            </div>
                            <div class="form-group">
                                <p>
                                    <b>Customer Numbers:</b>
                                    {{ customer.mobile }}
                                    {{ customer.alt_mobile }}
                                    {{ customer.phone }}
                                    {{ customer.alt_phone }}
                                </p>
                            </div>
                            <div class="form-group" v-if="addaddress == true">
                                <button
                                    class="btn btn-primary"
                                    @click="addCusAddress"
                                >
                                    <i class="fa fa-plus"></i> Add Address
                                </button>
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.billing_address ? 'has-error' : '',
                                ]"
                            >
                                <label>Communication Address *</label>
                                <select
                                    v-model="billing_address"
                                    class="form-control"
                                >
                                    <option
                                        v-for="j in addresses"
                                        :key="j.id"
                                        :value="j.id"
                                    >
                                        {{ j.addr_l1 }}, {{ j.addr_l2 }},
                                        {{ j.addr_l3 }}, {{ j.city }},
                                        {{ j.state }}, {{ j.pincode }}
                                    </option>
                                    <span
                                        v-if="errors.billing_address"
                                        :class="['badge bg-danger']"
                                        >Please choose an address.</span
                                    >
                                </select>
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.comm_address ? 'has-error' : '',
                                ]"
                            >
                                <label>Shipping Address *</label>
                                <select
                                    v-model="comm_address"
                                    class="form-control"
                                >
                                    <option
                                        v-for="j in addresses"
                                        :key="j.id"
                                        :value="j.id"
                                    >
                                        {{ j.addr_l1 }}, {{ j.addr_l2 }},
                                        {{ j.addr_l3 }}, {{ j.city }},
                                        {{ j.state }}, {{ j.pincode }}
                                    </option>
                                    <span
                                        v-if="errors.comm_address"
                                        :class="['badge bg-danger']"
                                        >Please choose an address.</span
                                    >
                                </select>
                            </div>
                            <div class="form-group">
                                <button
                                    class="btn btn-primary"
                                    @click="addCustomer"
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                    <!-- content here -->
                </div>
                <div class="card-footer"></div>
            </div>
            <!-- row end -->
        </section>
        <!-- /.content -->

        <div class="modal" tabindex="-1" role="dialog" id="adrsmodal">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Customer Address</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            v-if="allow == true"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="updateAddress">
                            <div
                                :class="[
                                    'form-group',
                                    errors.addr_l1 ? 'has-error' : '',
                                ]"
                            >
                                <label>Address Line 1 *</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter address line 1"
                                    v-model="aform.addr_l1"
                                />
                                <span
                                    v-if="errors.addr_l1"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid line.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.addr_l2 ? 'has-error' : '',
                                ]"
                            >
                                <label>Address Line 2</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter address line 2"
                                    v-model="aform.addr_l2"
                                />
                                <span
                                    v-if="errors.addr_l2"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid line.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.addr_l3 ? 'has-error' : '',
                                ]"
                            >
                                <label>Address Line 3</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter address line 3"
                                    v-model="aform.addr_l3"
                                />
                                <span
                                    v-if="errors.addr_l3"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid line.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.city ? 'has-error' : '',
                                ]"
                            >
                                <label>City *</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter city"
                                    v-model="aform.city"
                                />
                                <span
                                    v-if="errors.city"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid city.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.state ? 'has-error' : '',
                                ]"
                            >
                                <label>State *</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter state"
                                    v-model="aform.state"
                                />
                                <span
                                    v-if="errors.state"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid state.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.pincode ? 'has-error' : '',
                                ]"
                            >
                                <label>Pincode *</label>
                                <input
                                    type="number"
                                    class="form-control"
                                    placeholder="Enter pincode"
                                    v-model="aform.pincode"
                                    min="100000"
                                />
                                <span
                                    v-if="errors.pincode"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid pincode.</span
                                >
                            </div>
                            <div class="form-group">
                                <button class="btn btn-primary" type="submit">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="card-footer">
                        <button
                            class="btn btn-secondary"
                            data-dismiss="modal"
                            v-if="allow == true"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal" tabindex="-1" role="dialog" id="cstmrmodal">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Customer Details</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="updateCustomer">
                            <div
                                :class="[
                                    'form-group',
                                    errors.name ? 'has-error' : '',
                                ]"
                            >
                                <label>Name *</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter the customer name"
                                    v-model="form.name"
                                />
                                <span
                                    v-if="errors.name"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid name.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.gender ? 'has-error' : '',
                                ]"
                            >
                                <label>Gender *</label>
                                <select
                                    class="form-control"
                                    placeholder="Select customer gender"
                                    v-model="form.gender"
                                >
                                    <option value="M">Male</option>
                                    <option value="F">Female</option>
                                </select>
                                <span
                                    v-if="errors.gender"
                                    :class="['badge bg-danger']"
                                    >Please choose a valid gender.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.mobile ? 'has-error' : '',
                                ]"
                            >
                                <label>Phone 1 *</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter phone 1"
                                    v-model="form.mobile"
                                />
                                <span
                                    v-if="errors.mobile"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid phone number.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.alt_mobile ? 'has-error' : '',
                                ]"
                            >
                                <label>Phone 2</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter phone 2"
                                    v-model="form.alt_mobile"
                                />
                                <span
                                    v-if="errors.alt_mobile"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid phone number.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.phone ? 'has-error' : '',
                                ]"
                            >
                                <label>Phone 3</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter phone 3"
                                    v-model="form.phone"
                                />
                                <span
                                    v-if="errors.phone"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid phone number.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.alt_phone ? 'has-error' : '',
                                ]"
                            >
                                <label>Phone 4</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter phone 4"
                                    v-model="form.alt_phone"
                                />
                                <span
                                    v-if="errors.alt_phone"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid phone number.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.email ? 'has-error' : '',
                                ]"
                            >
                                <label>E-mail</label>
                                <input
                                    type="email"
                                    class="form-control"
                                    placeholder="Enter email address"
                                    v-model="form.email"
                                />
                                <span
                                    v-if="errors.email"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid email.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.alt_email ? 'has-error' : '',
                                ]"
                            >
                                <label>Alt E-mail</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter alternate email address"
                                    v-model="form.alt_email"
                                />
                                <span
                                    v-if="errors.alt_email"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid email.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.dob ? 'has-error' : '',
                                ]"
                            >
                                <label>DOB *</label>
                                <input
                                    type="date"
                                    class="form-control"
                                    placeholder="Enter date of birth"
                                    v-model="form.dob"
                                />
                                <span
                                    v-if="errors.dob"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid dob.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.membership_id ? 'has-error' : '',
                                ]"
                            >
                                <label>Membership ID</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter membership ID"
                                    v-model="form.membership_id"
                                />
                                <span
                                    v-if="errors.membership_id"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid membership ID.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.category ? 'has-error' : '',
                                ]"
                            >
                                <label>Category</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter the category"
                                    v-model="form.category"
                                />
                                <span
                                    v-if="errors.category"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid category.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.area ? 'has-error' : '',
                                ]"
                            >
                                <label>Area</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter the area"
                                    v-model="form.area"
                                />
                                <span
                                    v-if="errors.area"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid area.</span
                                >
                            </div>
                            <div class="form-group">
                                <button class="btn btn-primary" type="submit">
                                    Next
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <!-- All</div> VUE Parts end before this comment -->
        </div>
        <!--        </div>-->
        <!--        <div v-if="!$gate.isServiceAgent()">-->
        <!--             <access-denied></access-denied>-->
        <!--        </div>-->
    </div>
</template>

<script>
export default {
    mounted() {
        console.log("Component mounted.");
    },

    created() {
        this.getJob();
    },

    data() {
        return {
            form: new Form({
                name: "",
                uid: "",
                gender: "",
                mobile: "",
                alt_mobile: "",
                phone: "",
                alt_phone: "",
                email: "",
                alt_email: "",
                dob: "",
                membership_id: "",
                category: "",
                area: "",
                id: "",
            }),
            errors: [],
            heading: "",
            allow: false,
            aform: new Form({
                profile_id: "",
                addr_l1: "",
                addr_l2: "",
                addr_l3: "",
                city: "",
                state: "",
                pincode: "",
                id: "",
            }),
            number: "",
            customer: [],
            billing_address: "",
            comm_address: "",
            addresses: [],
            status: "",
            job: [],
            addaddress: false,
        };
    },

    methods: {
        getJob() {
            axios
                .post("/api/getJob", { id: this.$route.params.id })
                .then((response) => {
                    this.job = response.data;
                });
        },

        searchCus() {
            this.status = "Searching...";
            axios
                .post("/api/numberSearchCus", { number: this.number })
                .then((response) => {
                    if (response.data != "") {
                        this.customer = response.data;
                        this.status = "Search Complete!";
                        this.getAddresses();
                        this.addaddress = true;
                    } else this.status = "No results. Please add customer!";
                })
                .catch(() => {
                    this.status = "Search Error!";
                });
        },

        addCusAddress() {
            this.aform.profile_id = this.customer.id;
            $("#adrsmodal").modal("show");
        },

        updateCustomer() {
            this.form
                .post("/api/updateCustomerSA")
                .then((response) => {
                    if (response.data != null) {
                        toast.fire({
                            icon: "success",
                            title: "Customer Details Updated",
                        });
                        $("#cstmrmodal").modal("hide");
                        this.form.id = response.data;
                        this.number = this.form.mobile;
                        this.errors = [];
                        this.add();
                    } else
                        toast.fire({
                            icon: "error",
                            title: "Operation Failed",
                        });
                })
                .catch((errors) => {
                    toast.fire({
                        icon: "error",
                        title: "Operation Failed",
                    });
                    this.errors = errors.response.data.errors;
                });
        },

        add() {
            this.aform.profile_id = this.form.id;
            $("#adrsmodal").modal("show");
        },

        addCus() {
            $("#cstmrmodal").modal("show");
        },

        change(address) {
            this.heading = "Edit";
            this.aform.fill(address);
            $("#adrsmodal").modal("show");
        },

        updateAddress() {
            this.aform
                .post("/api/addLeadAddress")
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Addresses Updated",
                        });
                        this.errors = [];
                        this.allow = true;
                        this.searchCus();
                    }
                })
                .catch((errors) => {
                    toast.fire({
                        icon: "success",
                        title: "Failed",
                    });
                    this.errors = errors.response.data.errors;
                });
        },

        getAddresses() {
            axios
                .post("/api/getLeadAddresses", { id: this.customer.id })
                .then((response) => {
                    this.addresses = response.data;
                });
        },

        addCustomer() {
            axios
                .post("/api/addCustomerDets", {
                    customer_id: this.customer.id,
                    customer_phone: this.customer.mobile,
                    comm_address: this.comm_address,
                    billing_address: this.billing_address,
                    id: this.job.id,
                    customer_name: this.customer.name,
                })
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Job Updated",
                        });
                        this.errors = [];
                    }
                })
                .catch((errors) => {
                    toast.fire({
                        icon: "success",
                        title: "Failed",
                    });
                    this.errors = errors.response.data.errors;
                });
        },
    },
};
</script>
